import {get, patch, post} from "./request";

export const notificationApi = {};
const apiResource = "/notification";

notificationApi.getMe = async ({page, size}) => {
  try {
    const {data} = await post(
      apiResource + `/me/all`,
      {
        order: [["createdAt", "DESC"]],
      },
      {page, size}
    );
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

notificationApi.markAsRead = async () => {
  try {
    const {data} = await patch(apiResource + "/mark_as_read_all");
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};
